module.exports = __webpack_public_path__ + "img/transmissionIcon.162b1b35.svg";